import React from "react";

// Import Styles
import "../styles/About.css";

// Import Assets
import barber from "../assets/images/profile01.png";

function About() {
  return (
    <div className="About">
      <div className="About__Main-Container">
        <div className="Left-Container">
          <h1>Jowell's Barber </h1>
          <h2>
            Disfruta de la mejor experiencia de cuidado personal para hombres
          </h2>
          <p>
            Atendiendo desde el 2017, Jowell's Barber Shop se especializa en el
            cuidado personal para hombres. Atendemos a clientes que buscan una
            experiencia de barbería elevada y un ambiente relajado. Puedes
            contar con nuestros cortes de cabello excepcionales, afeitados,
            servicios de Spa. Nuestra Misión es ayudar a nuestros clientes a
            relajarse, verse bien y sentirse seguros.
          </p>
        </div>

        <div className="Right-Container">
          <img src={barber} alt="" />
        </div>
      </div>
    </div>
  );
}

export default About;
